import React from 'react'
import CareerForm from '../components/CareerForm/CareerForm'
import Footer from '../components/Footer/Footer'
import Navbar from '../components/Navbar/Navbar'

const Apply = () => {
  return (
    <>
      <Navbar />
      <CareerForm />
      <Footer />
    </>
  )
}

export default Apply